import React, { useState } from 'react';

import Toast from 'react-bootstrap/Toast';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Form from 'react-bootstrap/Form';
import FormControl from 'react-bootstrap/FormControl';
import Image from 'react-bootstrap/Image';
import Grid from 'react-bootstrap';
import { Row, Col } from 'react-bootstrap';

import RegistrationForm from './RegistrationForm';
import CzGlobals from './global';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamation } from '@fortawesome/free-solid-svg-icons';


import axios from 'axios';

import './App.scss';
import './App.css';


let search = window.location.search;
let params = new URLSearchParams(search);
let id_cliente = params.get('i');
let lang = params.get('l');
let session_id = params.get('s');

if (!id_cliente) {
  id_cliente = 0;
}

if (!session_id) {
  session_id = '1234567890';
}

if (!lang) {
  lang = 'en';
}

CzGlobals.id_cliente = id_cliente;
CzGlobals.id_sessione = session_id;
CzGlobals.lang = lang;

axios.defaults.headers.common['Cz-Session-Id'] = CzGlobals.id_sessione;


if (lang=='it') {
  CzGlobals.lang = 'it';
} else {
  CzGlobals.lang = 'en';
}


const Titolo = () => <h3 className="text-center">REGISTRATION FORM</h3>;


const App = () => (
 
  <Container fluid>
    <Navbar bg="light" >
      <Navbar.Brand href="#home"><Image src="https://www.czernys.com/czerny/wp-content/uploads/2016/12/logonero150.png" /></Navbar.Brand>
      <Nav className="mr-auto">

      </Nav>
      <Form inline>
      <FormControl type="text" placeholder="Search" className="mr-sm-2" />
      <Button variant="outline-success"><Image src="static/united-kingdom.png" rounded /></Button>
    </Form>
    </Navbar>

    <Container fluid="lg">
    <Row>
      <Col>
      <Titolo></Titolo>
      </Col>
    </Row>

    <Row>
      <RegistrationForm lang={CzGlobals.lang}></RegistrationForm>
    </Row>

    </Container>
    
  </Container>
);

export default App;
